import debug from 'debug';
import { loadAmplify } from './lazy-loaders';
// A class to wrap the dynamically imported AWS Amplify Auth library in
export class CognitoAuth {
    constructor({ hubOptions } = {}) {
        this.logger = debug(`mygrano:auth`);
        this.amplify = this.loadAmplify();
        this.cognitoAuth = this.loadAmplifyAuth(hubOptions);
    }
    async configure(...args) {
        const cognitoAuth = await this.cognitoAuth;
        return cognitoAuth.configure(...args);
    }
    async currentSession() {
        const cognitoAuth = await this.cognitoAuth;
        return cognitoAuth.currentSession();
    }
    /* istanbul ignore next */
    async loadAmplify() {
        const { Auth, Hub } = await loadAmplify();
        return { Auth, Hub };
    }
    async loadAmplifyAuth({ authEventHandlers, } = {}) {
        const { Auth: amplifyAuth, Hub: amplifyHub } = await this.amplify;
        await this.setupAuthEventHandlers(amplifyHub, authEventHandlers);
        return amplifyAuth;
    }
    async setupAuthEventHandlers(hub, authEventHandlers) {
        const authHandlers = authEventHandlers ?? {};
        if (Object.keys(authHandlers).length) {
            // If the handlers don't seem to work for some reason, make sure @aws-amplify/core version is correct.
            hub.listen('auth', async ({ payload }) => {
                // Enable debug logging by uncommenting:
                this.logger('Auth Event:', payload);
                await authHandlers?.[payload.event]?.(payload);
            });
        }
    }
}
